import { useCallback, useEffect, useState } from "react";
import api, { API_BASE } from "../lib/api";

// Prompt 18 B5/H3/H4/J4/F3 — super-admin security snapshot + audit log viewer.
function SecuritySnapshot() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/diagnostics/security").then((r) => setS(r.data)).catch(() => setS({ error: true })); }, []);
  if (!s) return <div className="text-sm text-neutral-500">Loading…</div>;
  if (s.error) return <div className="text-sm text-red-700">Could not load.</div>;
  return (
    <div className="space-y-3 text-sm">
      <div data-testid="diag-seed-accounts">Seed/demo accounts active: {s.seed_accounts_active}</div>
      <div data-testid="diag-stripe-mode">Stripe mode: {s.stripe_mode}</div>
      <table className="w-full text-xs">
        <thead><tr className="text-left label-mini"><th className="py-1">GL</th><th>tokens encrypted</th><th>requested scopes</th></tr></thead>
        <tbody>
          {Object.entries(s.tokens).map(([gl, t]) => (
            <tr key={gl} className="border-t border-neutral-200 align-top" data-testid={`diag-tokens-${gl}`}>
              <td className="py-1 font-mono">{gl}</td>
              <td>{t.encrypted ? "yes" : "no"} ({t.records} records)</td>
              <td className="font-mono break-all">{Array.isArray(s.scopes[gl]) ? s.scopes[gl].join(" ") : s.scopes[gl]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function AuditLog() {
  const [f, setF] = useState({ action: "", company: "", date_from: "", date_to: "" });
  const [data, setData] = useState({ rows: [], actions: [] });
  const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
  const load = useCallback(() => {
    api.get("/admin/audit-log", { params }).then((r) => setData(r.data)).catch(() => setData({ rows: [], actions: [] }));
  }, [JSON.stringify(params)]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load]);
  const csvUrl = `${API_BASE}/admin/audit-log?${new URLSearchParams({ ...params, format: "csv" })}`;
  const input = (k, type = "text", ph = "") => (
    <input type={type} value={f[k]} placeholder={ph} onChange={(e) => setF({ ...f, [k]: e.target.value })}
           className="border border-neutral-300 px-2 py-1 text-xs" data-testid={`audit-filter-${k}`} />
  );
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2 items-center">
        <select value={f.action} onChange={(e) => setF({ ...f, action: e.target.value })}
                className="border border-neutral-300 px-2 py-1 text-xs" data-testid="audit-filter-action">
          <option value="">all actions</option>
          {data.actions.map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
        {input("company", "text", "company id")}
        {input("date_from", "date")}
        {input("date_to", "date")}
        <a href={csvUrl} className="underline text-xs" data-testid="audit-export-csv">export CSV</a>
      </div>
      <div className="overflow-x-auto max-h-96">
        <table className="w-full text-xs">
          <thead><tr className="text-left label-mini"><th className="py-1">when</th><th>actor</th><th>action</th><th>target company</th><th>target</th><th>ip</th><th>result</th></tr></thead>
          <tbody>
            {data.rows.map((r, i) => (
              <tr key={i} className="border-t border-neutral-200" data-testid="audit-row">
                <td className="py-1 font-mono">{new Date(r.at).toLocaleString()}</td>
                <td>{r.actor_name || r.actor_user_id}</td><td>{r.action}</td>
                <td className="font-mono">{r.target_company_id || "—"}</td><td>{r.target || "—"}</td>
                <td className="font-mono">{r.ip || "—"}</td><td>{r.result}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function DiagnosticsSecurity() {
  return (
    <>
      <section className="card-flat p-6" data-testid="diag-security-section">
        <div className="label-mini mb-3">Security</div>
        <SecuritySnapshot />
      </section>
      <section className="card-flat p-6" data-testid="diag-audit-section">
        <div className="label-mini mb-3">Admin audit log</div>
        <AuditLog />
      </section>
    </>
  );
}
